import { api } from "@/lib/api";
import { toast } from "sonner";

export const BASE = "/admin/supplier-hub";

export const call = async (fn, ok) => {
  try {
    const { data } = await fn();
    if (ok) toast.success(typeof ok === "function" ? ok(data) : ok);
    return data;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Something went wrong");
    return null;
  }
};

export const get = (path, params) => api.get(`${BASE}${path}`, { params }).then((r) => r.data);

export const nz = (v) => (v ? new Date(v).toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : "—");

export const STATUS = {
  queued: "bg-sky-100 text-sky-800", running: "bg-amber-100 text-amber-800", completed: "bg-emerald-100 text-emerald-800",
  failed: "bg-red-100 text-red-700", cancelled: "bg-slate-200 text-slate-700", timed_out: "bg-orange-100 text-orange-800",
  applied: "bg-emerald-100 text-emerald-800", rolled_back: "bg-slate-200 text-slate-700", partial: "bg-orange-100 text-orange-800",
  retrying: "bg-orange-100 text-orange-800",
};

export const Pill = ({ s, testid, label }) => (
  <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold ${STATUS[s] || "bg-slate-100 text-slate-700"}`} data-testid={testid}>
    {label || (s || "—").replace(/_/g, " ")}
  </span>
);

export const JOB_TYPES = [["stock", "Stock Update"], ["price", "Price Update"], ["full", "Full Update"], ["info", "Product Info Update"], ["media_check", "Media URL Check"]];
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const freqText = (s) => {
  if (!s) return "—";
  if (s.frequency === "hourly") return `Hourly at :${(s.time || "00:00").split(":")[1]}`;
  if (s.frequency === "weekly") return `Weekly, ${WEEKDAYS[s.weekday ?? 6]} ${s.time}`;
  if (s.frequency === "custom") return `Every ${s.interval_hours}h from ${s.time}`;
  return `Daily, ${s.time}`;
};
